module.exports = __webpack_public_path__ + "static/media/vision.bd49725f.svg";